import { useRef } from 'react'
import { Controller } from 'react-hook-form'
import AddressFields from '@/components/AddressFields'
import { Input } from '@/components/ui'
// import SuggestionField from './SuggestionField'
import ContactFields from './ContactFields'

const FormeJuridiqueList = ['EIRL', 'EURL', 'SA', 'SARL', 'SAS', 'SASU', 'SNC', 'SCI', 'SCS', 'SCOP']

const PersonneMoraleForm = ({ control, watch, errors, apiErrors }) => {

  // Référence pour le composant ContactFields
  const contactFieldsRef = useRef(null)

  const formeJuridique = watch('civilite')

 // Fonction utilitaire pour obtenir l'erreur combinée (du form ou de l'API)
  const getErrorMessage = (fieldName) => errors?.[fieldName]?.message || apiErrors?.[fieldName] || '';

  // Fonction utilitaire pour déterminer si un champ a une erreur
  const hasError = (fieldName) => !!errors?.[fieldName] || !!apiErrors?.[fieldName]

  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <div className="flex flex-col items-center gap-2 pt-4">
          <Controller 
            name="civilite"
            control={control}
            defaultValue=""
            render={({field}) => (
              <label className="select w-2/3">
                <span className='label'>Forme juridique</span>
                <select 
                  {...field} 
                  value={field.value || ''}
                >
                  <option value='' disabled={true} className="">Choisir une forme</option>
                  {
                    FormeJuridiqueList.map((civilite) => (
                      <option key={civilite} value={civilite}>{civilite}</option>
                    ))
                  }
                </select>
              </label>
            )}
          />

          <Controller
            name="nom"
            control={control}
            defaultValue=""
            rules={{ required: "La raison sociale doit être renseignée." }}
            render={({ field  }) => (
              <>
                <label className="input validator w-2/3"
                        {...(hasError('nom') ? {'aria-invalid': true} : {})}
                >
                  <span className="label">Raison sociale</span>
                  <input 
                    type="text" 
                    {...field}
                    value={field.value || ''} 
                  />
                </label>
                <p className="validator-hint hidden mt-0 w-2/3 empty:py-[0.6rem]">{getErrorMessage('nom')}</p>
              </>
            )}
          />

          <Input.Siret 
            control={control} 
            validator={{hasError, getErrorMessage}}
            className="w-2/3" 
          /> 

          <div className="flex flex-col w-2/3">
            <ContactFields ref={contactFieldsRef}
              control={control}
              validator={{hasError, getErrorMessage}}
            />
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <AddressFields control={control} errors={errors} apiErrors={apiErrors} without={['pays']}/>
          
          { formeJuridique !== "SCI" && (
            <>
              <div className='w-full flex flex-col items-center gap-2'>
                <Input.PhoneNumber control={control}
                  name="telephone"
                  className="w-2/3"
                  validator={{hasError, getErrorMessage}}
                />
              </div>

              <div className='w-full flex flex-col items-center gap-2'>
                <Input.Email control={control}
                  name="email"
                  className="w-2/3"
                  validator={{hasError, getErrorMessage}}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default PersonneMoraleForm